import React from 'react';
import {
  FormControl, MenuItem, Select, WithStyles,
} from '@material-ui/core';
import styles from './styles';

type Option = {
  label: string;
  value: string | number;
};

type Props = {
  label: string;
  options: Option[] | string[];
  multiple?: boolean;
  value: (string | number) | (string | number)[];
  onChange: (val: any) => void;
} & WithStyles<typeof styles>;

const isOption = (opt: Option | string): opt is Option => typeof opt === 'object';

export const FilterSelect = (props: Props) => {
  const {
    label, onChange, value, options, classes, multiple,
  } = props;

  return (
    <FormControl className={classes.formControl}>
      <Select
        multiple={multiple}
        displayEmpty
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={classes.select}
        inputProps={{ classes: { icon: classes.icon } }}
        renderValue={(selected) => {
          if (multiple) {
            const selectedArr = selected as (string | number)[];
            return (
              <div className={classes.label}>
                <span>{label}</span>
                {selectedArr.length > 0 && (
                  <span className={classes.badge}>{selectedArr.length}</span>
                )}
              </div>
            );
          }

          const isObjectOptions = options.length > 0 && typeof options[0] === 'object';
          const selectedLabel = isObjectOptions
            ? (options as Option[]).find((o) => o.value === (selected as string | number))?.label
            : (selected as string);

          return (
            <div className={classes.label}>
              <span>{selectedLabel || label}</span>
            </div>
          );
        }}
        MenuProps={{
          PaperProps: { className: classes.menuPaper },
          getContentAnchorEl: null,
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        }}
        disableUnderline={false}
      >
        {(options as Array<Option | string>).map((opt) => (
          <MenuItem
            key={isOption(opt) ? opt.value : opt}
            value={isOption(opt) ? opt.value : opt}
            className={classes.menuItem}
          >
            {isOption(opt) ? opt.label : opt}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
